import React from 'react';
import { Navigate } from 'react-router-dom';

import { PageLayout } from '../../../../shared/components/page-layout/page-layout';
import { ThemeSwitch } from '../../../../shared/components/theme-switch/theme-switch';
import AllAppsLayout from '../../../app-store/components/AllAppsLayout/AllAppsLayout';
import AppCreateLayout from '../../../app-store/components/AppCreateLayout/AppCreateLayout';
import Apps from '../../../app-store/components/Apps/Apps';
import { RatingsAndReviews } from '../../../app-store/components/RatingsAndReviews/components/ratings-and-reviews/ratings-and-reviews';
import ReleasesLayoutWrapper from '../../../app-store/components/ReleasesLayout/ReleasesLayout';
import { Statistics } from '../../../app-store/components/Statistics/components/Statistics';
import AppDetailsForm from '../../../app-store/components/ui/AppDetailsForm';
import { appsFilesActions } from '../../../app-store/store/slices/apps-files.slice';
import { releasesActions } from '../../../app-store/store/slices/releases.slice';
import { createAppRelease } from '../../../app-store/thunks/create-app-release.thunk';
import Logout from '../../../authentication/components/Logout';
import { getCampaignsRoutes } from '../../../campaigns-management/utils/campaign-routes/campaigns-routes.util';
import Firmware from '../../../firmware-management/components/Firmware/Firmware';
import FirmwareForm from '../../../firmware-management/components/FirmwareForm/FirmwareForm';
import FirmwarePageLayout from '../../../firmware-management/components/FirmwarePageLayout/FirmwarePageLayout';
import { getWebGamesRoutes } from '../../../web-games/utils/routes/get-web-games-routes.util';
import { ReactComponent as AppStore } from '../../assets/icons/menu-icons/appstore1x.svg';
import { ReactComponent as Help } from '../../assets/icons/menu-icons/help1x.svg';
import { ReactComponent as FirmwareManagement } from '../../assets/icons/menu-icons/sm1x.svg';
import { ReactComponent as Vehicles } from '../../assets/icons/menu-icons/vehicle1x.svg';
import Layout from '../../components/layout/Layout';
import { RouteProps } from '../../models/route-props.model';

const campaignsRoutes: RouteProps[] = getCampaignsRoutes();
const gamesRoutes: RouteProps[] = getWebGamesRoutes();

export const getRoutes = (): RouteProps[] => [
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: 'appstore',
        title: 'Apps',
        element: <Apps />,
        menuIcon: <AppStore className="svg-icon" />,
        children: [
          {
            path: 'all-apps',
            title: 'All apps',
            element: <AllAppsLayout />,
          },
          {
            path: 'all-apps/create',
            title: 'Create',
            element: <AppCreateLayout />,
            notVisibleInMenu: true,
            children: [
              {
                // TODO: Confirm if user should be redirected to all apps or that a 404 Not Found page should be shown
                path: '',
                title: 'App Details',
                element: <Navigate to={'/appstore/all-apps'} />,
              },
              {
                path: 'details',
                title: 'Details',
                element: <AppDetailsForm />,
              },
              {
                path: 'releases',
                title: 'Releases',
                element: (
                  <ReleasesLayoutWrapper
                    wrappedComponentProps={{
                      onReset: releasesActions.resetReleasesSliceState,
                    }}
                    wrappedWithSearchComponentProps={{
                      submitThunk: createAppRelease,
                      onToggleForm: appsFilesActions.resetAppsFilesState,
                    }}
                  />
                ),
              },
              {
                path: 'ratings-reviews',
                title: 'Rating & Reviews',
                element: <RatingsAndReviews />,
              },
              {
                path: 'statistics',
                title: 'Statistics',
                element: <Statistics />,
              },
            ],
          },

          {
            path: 'all-apps/edit/:id',
            title: 'Create',
            element: <AppCreateLayout />,
            notVisibleInMenu: true,
            children: [
              {
                // TODO: Confirm if user should be redirected to all apps or that a 404 Not Found page should be shown
                path: '',
                title: 'Details',
                element: <Navigate to={'/appstore/all-apps'} />,
              },
              {
                path: 'details',
                title: 'Details',
                element: <AppDetailsForm />,
              },
              {
                path: 'releases',
                title: 'Releases',
                element: (
                  <ReleasesLayoutWrapper
                    wrappedComponentProps={{
                      onReset: releasesActions.resetReleasesSliceState,
                    }}
                    wrappedWithSearchComponentProps={{
                      submitThunk: createAppRelease,
                      onToggleForm: appsFilesActions.resetAppsFilesState,
                    }}
                  />
                ),
              },
              {
                path: 'ratings-reviews',
                title: 'Rating & Reviews',
                element: <RatingsAndReviews />,
              },
              {
                path: 'statistics',
                title: 'Statistics',
                element: <Statistics />,
              },
            ],
          },
        ],
      },
      ...gamesRoutes,
      {
        path: 'firmware-management',
        title: 'Firmwares',
        element: <FirmwarePageLayout />,
        menuIcon: <FirmwareManagement className="svg-icon" />,
        children: [
          {
            path: 'firmwares',
            title: 'Firmware',
            element: <Firmware />,
          },
          {
            path: 'create',
            title: 'Create',
            element: <FirmwareForm />,
            notVisibleInMenu: true,
          },
          {
            path: 'edit/:id',
            title: 'Update Firmware',
            element: <FirmwareForm />,
            notVisibleInMenu: true,
          },
        ],
      },
      ...campaignsRoutes,
      {
        path: 'vehicles',
        title: 'Vehicles',
        element: <div>Vehicles</div>,
        menuIcon: <Vehicles className="svg-icon" />,
      },
      {
        path: 'help',
        title: 'Help',
        element: <PageLayout title="Help" />,
        menuIcon: <Help className="svg-icon" />,
        children: [
          {
            path: '',
            title: 'Theme Switch',
            element: <ThemeSwitch />,
            notVisibleInMenu: true,
          },
        ],
      },
      {
        path: 'logout',
        element: <Logout />,
        notVisibleInMenu: true,
      },
    ],
  },
];

export const accountSettings: RouteProps[] = [
  {
    path: 'logout',
    title: 'Logout',
  },
];
